<template>
    <van-popup class="popup" v-model="showPopup" get-container="body" :close-on-click-overlay="false">
        <div class="jump-modal">
            <div class="title">需前往支付宝验证学生身份</div>
            <div class="jump-loading">
                <i class="qsk-logo" />
                <div class="progress">
                    <div class="progress-bar">
                        <div class="progress-bar__icon"></div>
                    </div>
                </div>
                <i class="supplier-logo"></i>
            </div>
            <div class="desc">
                <p>您当前支付宝账号需与充值帐号</p>
                <p>（{{ phone }}）一致，才可认证</p>
            </div>
            <div class="footer">{{ countdownSecond }}s 后自动跳转</div>
        </div>
    </van-popup>
</template>

<script>
import VanPopup from 'vant/lib/popup';
import 'vant/lib/popup/style';

export default {
    name: 'AlipayStudentCert',
    components: {
        VanPopup,
    },
    props: {
        value: {
            type: Boolean,
            value: false,
        },
        phone: {
            type: String,
            value: '',
        },
    },
    data() {
        return {
            countdownSecond: 0,
            timer: null,
        };
    },
    mounted() {},
    computed: {
        showPopup: {
            get() {
                return this.value;
            },
            set(newVal) {
                this.$emit('input', newVal);
            },
        },
    },
    watch: {
        showPopup: {
            handler(val) {
                if (val) {
                    this.startCountdown();
                } else {
                    this.clearCountdown();
                }
            },
            immediate: true,
        },
    },
    methods: {
        //开始倒计时
        startCountdown() {
            this.countdownSecond = 3;
            this.countdown();
        },
        clearCountdown() {
            this.countdownSecond = 3;
            if (this.timer) {
                clearTimeout(this.timer);
            }
        },
        //倒计时
        countdown() {
            if (this.countdownSecond <= 0) {
                this.countdownSecond = 0;
                clearTimeout(this.timer);
                this.$emit('time-after');
                return;
            }
            this.timer = setTimeout(() => {
                this.countdownSecond -= 1;
                this.countdown();
            }, 1000);
        },
    },
};
</script>

<style lang="scss" scoped>
@keyframes moveArrow {
    0% {
        background-position: 0 0;
    }

    100% {
        background-position: -7.8rem 0;
    }
}

@-webkit-keyframes moveArrow {
    0% {
        background-position: 0 0;
    }

    100% {
        background-position: -7.8rem 0;
    }
}
.popup {
    overflow: initial;
    background-color: transparent;
    z-index: 9000;
}
.jump-modal {
    width: 6.3rem;
    padding: 0.4rem 0.6rem 0;
    box-sizing: border-box;
    background-image: url('./img/bg.png');
    background-position: 0% 0%;
    background-repeat: no-repeat;
    background-size: contain;
    border-radius: 0.16rem;
    position: relative;
    overflow: initial;

    .title {
        text-align: center;
        height: 0.44rem;
        font-size: 0.36rem;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #333333;
        line-height: 0.44rem;
        margin: 0 auto;
    }

    .jump-loading {
        display: flex;
        margin-top: 0.4rem;
        align-items: center;
        justify-content: center;
        .qsk-logo,
        .supplier-logo {
            width: 0.9rem;
            height: 0.9rem;
            background-size: 100% 100%;
            border-radius: 0.18rem;
        }
        .qsk-logo {
            background-image: url('./img/qsk-logo.png');
        }
        .supplier-logo {
            background-image: url('./img/ali.png');
        }
        .progress {
            display: flex;
            align-items: center;
            flex-direction: column;
            margin: 0 0.4rem;
            &-bar {
                width: 100%;
                height: 0.27rem;
                position: relative;
                &__icon {
                    width: 1.3rem;
                    height: 0.27rem;
                    margin: 0 auto;
                    background: url('./img/ae-arrow-v2.png') no-repeat center;
                    background-size: 7.8rem 0.27rem;
                    animation: moveArrow 1s steps(6) infinite;
                }
            }
            &-tips {
                font-size: 0.24rem;
                font-family: PingFangSC-Regular, PingFang SC;
                font-weight: 400;
                color: #333333;
                line-height: 0.33rem;
                text-align: center;
                margin-top: 0.15rem;
            }
        }

        .progress-bar__anim {
            position: absolute;
            left: 50%;
            top: 50%;
            transform: translate(-50%, -50%);
            &.is-app {
                left: 0;
                top: 0;
                transform: scale(0.5) translate(0, -50%);
            }
        }
    }

    .desc {
        margin: 0.3rem auto 0;
        text-align: center;
        font-size: 0.28rem;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #333333;
        line-height: 0.44rem;
    }

    .footer {
        position: relative;
        padding: 0.29rem 0 0.4rem;
        border-width: 0;
        text-align: center;
        font-size: 0.32rem;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #999999;
        line-height: 0.44rem;
        margin-top: 0.4rem;
        border-top: 0.5px dashed rgba(230, 228, 221, 1);
    }
}
</style>
